













import Modals from './Modals.vue';
import Notice from '~/components/common/Notice/Notice.vue';
import Tooltip from '~/components/common/Tooltip/Tooltip.vue';

export default {
  name: 'GlobalComponents',
  components: {
    Modals,
    Notice,
    Tooltip,
  },
};
